import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import SkillCourses from "./components/SkillCourses";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import ScrollToTop from "./components/ScrollToTop";

function HomePage() {
  return (
    <>
     
      <Hero />
      <Categories />
      <SkillCourses />
       <ScrollToTop />
    </>
  );
}

function App() {
  return (

    
    <Router basename="/smarty">
      <div className="font-sans bg-gray-950 text-gray-100">
        <Navbar />

        <Routes>
          {/* Home page */}
          <Route path="/" element={<HomePage />} />

          {/* If website opens at /smarty or any other path → show home */}
          <Route path="*" element={<HomePage />} />

          {/* Other pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
